import { Card, CardBody, Col, Row } from "reactstrap";
import { BackgroundColors } from "../../../../Constant";
import { BACKGROUND_DATE } from "../../../../Data/UiKit/HelperClasses";
import { DarkBackgrounds } from "./DarkBackground";
import { LightBackgrounds } from "./LightBackgrounds";
import { ExtendedBackgroundColors } from "./ExtendedBackgroundColors";
import CommonCardHeader from "../../../../Common/CommonCardHeader";

const BackgroundColorsCart = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={BackgroundColors} span={BACKGROUND_DATE} />
        <CardBody>
          <Row className="g-3">
            <DarkBackgrounds />
            <LightBackgrounds />
            <ExtendedBackgroundColors />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BackgroundColorsCart;
